import React from 'react';

interface Props {
  text: string;
  noImg?: boolean;
}

function Empty({ text, noImg }: Props) {
  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center">
      {!noImg && (
        <svg width="80" height="69">
          <g stroke="#D8D8D8" strokeWidth="2" fill="none" fillRule="evenodd">
            <path d="M6.18 1v61.181H79V1H6.18z" fill="#F3F3F3" />
            <path fill="#FFF" d="M1 5.819h72.82V67H1z" />
            <path
              d="M47.091 42.86l26.717 23.033V49.521L57.49 35.533l-10.399 7.328zm27 23.277l.281.243-.564-.21v-.033h.283z"
              fill="#F3F3F3"
            />
            <ellipse
              fill="#F3F3F3"
              cx="62.121"
              cy="17.95"
              rx="5.143"
              ry="5.1"
            />
            <path d="M74.04 67.325L22.415 22.488 1.15 39.58" />
          </g>
        </svg>
      )}
      <div className="mt-2.5 text-lg text-black-gray">{text}</div>
    </div>
  );
}

export default Empty;
